<template>
    <div class="introductionBox">
       <businessBanner tabIndex="3"></businessBanner>
       <div :class="isMobile?'mobileShow':'mainShow'">
            <p class="font20 fontw">招标采购</p>
            <p class="mt36 jies">招标采购业务是集团最早开展的业务板块，早在2000年集团成立之初就作为主营业务发展至今。集团公司也是省内最早一批取得工程建设甲级、政府采购甲级、中央投资甲级、国际招标甲级等原四甲招标资质的代理机构之一。</p>
       </div>
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main clearfix'">
                <div :class="isMobile?'contM':'fl contLeft'">
                    <div :class="isMobile?'contTM':'contT'">招标采购业务</div>
                    <p>集团招标采购项目年立项2600余项，年累计招标资金数百亿元，无论在项目数量还是在招标金额方面，集团招标采购业务常年稳居省内前三。</p>
                </div>
                <img :class="isMobile?'contImgShow':'fr zhaobImg'" src="@/assets/businessScope/zhaob.png" alt="">
            </div>
       </div>
       <div :class="isMobile?'mainM':'main clearfix'">
            <p v-if="isMobile" :class="isMobile?'contTM':'contT'">典型案例</p>
            <img :class="isMobile?'contImgShow':'fl xmImg'" src="@/assets/businessScope/xingm.png" alt="">
            <div :class="isMobile?'contM':'fr contd'">
                <div v-if="!isMobile" :class="isMobile?'contTM':'contT'">典型案例</div>
                <p>行业领域覆盖全面，业绩案例影响广泛，完成的典型案例有邢衡、京新、南绕城、延崇、京雄、荣乌、秦唐、绥满、曲港等高速公路主体工程、石家庄新客站项目、石家庄轨道交通1-6号线工程等国家及省市重点项目招标。</p>
            </div>
        </div>
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main clearfix'">
                <div :class="isMobile?'contM':'fl contLeft'">
                    <div :class="isMobile?'contTM':'contT'">业务荣誉</div>
                    <p>凭借优良的资信水平、突出的业务能力以及丰富的业绩案例，集团获得了多家国家及省级行业权威机构认可：中国招标投标协会AAA级信用企业、中国招标投标协会会员单位、河北省招标投标协会副会长单位、河北省公共资源交易协会副会长单位，并多次获得国家及省市级荣誉称号：全国政府采购百强代理机构、全国政府采购十佳代理机构、全国招标采购机构诚信单位、中国招标采购机构综合实力百强等。</p>
                </div>
                <img :class="isMobile?'contImgShow':'fr yjalImg'" src="@/assets/businessScope/yjal.png" alt="">
            </div>
       </div>
       <!-- 典型业绩展示 -->
       <TypicalAchievement category-id="100136" :show-tabs="false"  />
    </div>
</template>

<script>
import businessBanner from '@/components/businessBanner'
import TypicalAchievement from '@/components/TypicalAchievement.vue'
	export default {
		name:'EarlierConsultation',
        components:{businessBanner, TypicalAchievement},
        data() {
            return {

            }
        },
        mounted() {

        }
	}
</script>

<style scoped>
    .introductionBox{
        padding-bottom: 50px;
    }
    .mainShows{
        width: 100%;
        background-color: #F7F9FD;
        margin-top: 42px;
    }
    .mobileShows{
        width: 100%;
        background-color: #F7F9FD;
        margin-top: 20px;
    }
    .main{
        width: 1200px;
        margin: 0 auto;
        padding-top:47px;
        padding-bottom: 100px;
    }
    .mainM{
        width: 100%;
        margin: 0 auto;
        padding: 10px;
    }
    .jies{
        line-height: 30px;
        text-indent: 2em;
    }
    .cont{
        width: 525px;
        color: #666;
    }
    .contM{
        width: 100%;
        color: #666;
        line-height: 30px;
    }
    .contM p{
        text-indent: 2em;
    }
    .contT{
        color: #247CD6;
        font-size: 28px;
        margin-top: 60px;
        margin-bottom: 31px;
    }
    .contTM{
        color: #247CD6;
        font-size: 28px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .contT+p{
        line-height: 36px;
    }
    .contTM+p{
        line-height: 30px;
        text-indent: 2em;
    }
    .contImgShow{
        max-width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .zhaobImg{
        width: 372px;
        margin-right: 170px;
        margin-top: 66px;
    }
    .dianx{
        width: 678px;
        margin-left: -10px;
        margin-top: 22px;
    }
    .contd{
        width: 530px;
        color: #666;
    }
    .contLeft{
        width:525px;
        color: #666;
        margin-top: 30px;
    }
    .yjalImg{
        width: 608px;
        margin-top: 57px;
        margin-bottom: 105px;
    }
</style>